// Moroccan cities (Arabic) — used by the school-settings "city" dropdown
// (Signup + TenantAdmin). The selected value is stored verbatim on
// `tenant.location`, which the certificate generator interpolates into the
// date line ("<city>، في <date>"). Kept as a plain sorted list so the
// Autocomplete can offer the full set while still allowing a free-typed
// value for anything not listed.
const MOROCCO_CITIES = [
  'أكادير',
  'الحسيمة',
  'الخميسات',
  'الداخلة',
  'الدار البيضاء',
  'الرباط',
  'الرشيدية',
  'السمارة',
  'العرائش',
  'العيون',
  'الفقيه بن صالح',
  'القنيطرة',
  'القصر الكبير',
  'المحمدية',
  'الناظور',
  'الجديدة',
  'إفران',
  'ابن جرير',
  'أزرو',
  'أزيلال',
  'أسفي',
  'أصيلة',
  'بركان',
  'بنسليمان',
  'بني ملال',
  'بوجدور',
  'بوعرفة',
  'تارودانت',
  'تازة',
  'تاوريرت',
  'تطوان',
  'تنغير',
  'تيزنيت',
  'جرسيف',
  'زاكورة',
  'سطات',
  'سلا',
  'سيدي إفني',
  'سيدي سليمان',
  'سيدي قاسم',
  'شفشاون',
  'طاطا',
  'طانطان',
  'طنجة',
  'فاس',
  'فكيك',
  'قلعة السراغنة',
  'مراكش',
  'مكناس',
  'ميدلت',
  'وجدة',
  'ورزازات',
  'وزان',
  'يوسفية',
];

// Append the country so glance surfaces (certificates, reports) always read
// "<city>، المغرب". Idempotent: a free-typed value that already ends with
// "المغرب" (with or without the separating comma) is returned unchanged, and
// an empty/blank location yields an empty string.
export function formatLocationWithCountry(location) {
  const city = (location || '').trim();
  if (!city) return '';
  if (/المغرب\s*$/.test(city)) return city;
  return `${city}، المغرب`;
}

export default MOROCCO_CITIES;
